/******************
 * Detect browser user agent
 * Usage:
		-------Check Specific Browser---------
			browser.get('chrome') // true or false
		-------Get Current Browser---------
			browser.get() // chrome, firefox, opera, safari, ie, or edge
******************/
import { util } from '~/core';
const browser = {
	get(ua) {
		const browsers = {
			opera: ((!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0),
			firefox: (typeof InstallTrigger !== 'undefined'),
			safari: (/constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification))),
			ie: (/*@cc_on!@*/false || !!document.documentMode),
			edge: (!this.ie && !!window.StyleMedia),
			chrome: (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)),
		}
		if (ua) {
			return browsers[ua.toLowerCase()]
		}
		for (let key in browsers) {
			if (browsers[key]) {
				return key
			}
		}
		return undefined
	}
}

export default browser
util.browser = browser